'use client'

/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/semi */
/* eslint-disable arrow-body-style */
import React, { useEffect, useRef, memo } from 'react'
import DateComponent from '@components/Ackodrive/common/DateComponent'
import assetLoader from '@utils/internalImageLoader'
import AuthorComponent from '@components/Ackodrive/author'
import Tags from '@components/Ackodrive/Tags'
import TableOfContents from '@components/Ackodrive/common/TableOfContents'
import ContentWithoutRef from '@components/Ackodrive/HtmlContentRender/contentWithoutRef'
import { getTableOfContentsFromPost } from '@components/Ackodrive/common/utils'
import MainContentWithRef from '@components/Ackodrive/HtmlContentRender/mainContentWithRef'
import { ThemeProvider, AckoMainTheme } from '@acko-tech/building-blocks.ui.theme'
import Image from 'next/image'
import { SocialShareWidget } from '@acko-tech/building-blocks.ui.social-share-widget'
import { pageEvent, waitForAnalyticsLoad } from '@acko-tech/building-blocks.ui.acko-analytics'
import { ITEM_ID_VS_VIEW_SEGMENT_EVENTS } from '@components/Ackodrive/common/segementconstants'
import { NEWS_SHARE_WIDGET_URL } from '@components/Ackodrive/common/constants'
import { segmentEventCommonPropFuncAckoDrive } from '@utils/segmentProperties'
import logger from '@utils/logger'
import styles from './leftcontainer.module.scss'

const LeftContainer = ({ post, createdAt, updatedAt, itemType, itemId }) => {
  const afterToCNode = useRef<{ parent: Function }>()
  const hasRun = useRef(false)

  const getPostUrl = () => {
    if (typeof window !== 'undefined') {
      return window?.location?.href
    }
  }

  useEffect(() => {
    if (!hasRun.current) {
      waitForAnalyticsLoad()
        .then(() => {
          setTimeout(() => {
            const properties = segmentEventCommonPropFuncAckoDrive({ pageType: itemId })
            pageEvent(ITEM_ID_VS_VIEW_SEGMENT_EVENTS[itemId], {
              ...properties,
            })
          }, 100)
        })
        .catch(err => {
          logger.info('Wait for analytics load error', err)
        })
      hasRun.current = true
    }
  }, [])

  const toc = getTableOfContentsFromPost()(post)

  return (
    <div className={styles.LeftItemContainer}>
      <h1
        id="MainPageHeading"
        key={post?.attributes?.title || post?.attributes?.articleTitle}
        className={styles.HeadingOne}>
        {post?.attributes?.title || post?.attributes?.articleTitle}
      </h1>
      <DateComponent createdAt={createdAt} updatedAt={updatedAt} />
      <div id="AuthorAndInteractiveWidgets" className={styles.LeftSubHeading}>
        <AuthorComponent data={post?.attributes?.authorName} post={post} contentType={itemType} />
        <div className={styles.WidgetWrapper}>
          <a href={NEWS_SHARE_WIDGET_URL} target="_blank" className={styles.NewsShareWidget}>
            Follow us on
            <Image
              src={`${assetLoader()}/images/google-news-icon.svg`}
              alt="follow-google-news-icon"
              width="30"
              height="24"
            />
          </a>
          <div className={styles.SocialShareWidgetWrapper}>
            <ThemeProvider theme={AckoMainTheme}>
              <SocialShareWidget
                sharePostIconStyles={{ stroke: '#5b5675' }}
                textStyles={{ color: '#5b5675' }}
                postUrl={getPostUrl()}
                ctaText="Share Post"
              />
            </ThemeProvider>
          </div>
        </div>
      </div>
      <ContentWithoutRef data={post?.attributes?.contentBeforeToc} />
      {!!toc && <TableOfContents list={toc} />}
      <MainContentWithRef data={post?.attributes?.contentAfterToc} ref={afterToCNode} />
      <Tags tags={post?.attributes?.tags} />
    </div>
  )
}

export default memo(LeftContainer)
